// extracted by css-extract-rspack-plugin
export default {"Flash":"OverridingGlobalFundingFileWarning-module__Flash__RY_AxMY"};